/**
 * Bind - Reactive text/value binding node.
 *
 * Normalizes dynamic text-like children onto the same reactive child path used
 * by the JSX runtime.
 *
 * @module @smoothie-framework/ui/control
 */
import { createNodeId } from '../render/node-id';
import { normalizeChildNodes } from '../render/child-nodes';
export function Bind(props) {
    return {
        id: createNodeId(),
        type: 'Fragment',
        props: {},
        children: normalizeChildNodes(props.children, { treatFunctionsAsReactiveText: true }),
    };
}
//# sourceMappingURL=Bind.js.map